import { useTranslation } from "react-i18next";
import styles from "./Publication.module.css";
import { SectionTitle } from "../../PresentationalComponents/SectionTitle";
import {
  Award,
  GraduationCap,
  Handshake,
  PenTool,
  Printer,
  Rocket,
  SquareCheck,
  SquareText,
  Summary,
  Trophy,
} from "lucide-react";
import { Tag } from "../../PresentationalComponents/Tag";

const formatter = new Intl.NumberFormat("fa-IR");
const publicationDictionary = {
  en: {
    sectionTitle: "PUBLICATION",
    sectionNum: "07",
    title: "Title: ",
    authors: "Authors: ",
    publisher: "Poblisher:",
    abstract: "Abstract:",
    responsibilities: "Responsibilities:",
  },
  fa: {
    sectionTitle: "مقالات",
    sectionNum: "۰" + formatter.format(7),
    title: "عنوان مقاله: ",
    authors: "نویسندگان: ",
    publisher: "منتشر‌کننده:",
    abstract: "چکیده مقاله:",
    responsibilities: "مسئولیت‌ها: ",
  },
};
const publication = {
  en: {
    title: "ROAD: The ROad event Awareness Dataset for Autonomous Driving",

    authors:
      "Gurkirt Singh, Stephen Akrigg, Manuele Di Maio, Valentina Fontana, Reza Javanmard Alitappeh, Suman Saha, Kossar Jeddisaravi, Farzad Yousefi , Jacob Culley, Tom Nicholson, Jordan Omokeowa, Salman Khan, Stanislao Grazioso, Andrew Bradley, Giuseppe Di Gironimo, Fabio Cuzzolin",

    venue:
      "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI)",

    year: "2022",

    categories: [
      "Computer Vision",
      "Artificial Intelligence",
      "Autonomous Driving",
      "Robotics",
      "Deep Learning",
    ],

    description:
      "ROAD is a large-scale dataset designed for understanding and detecting road events in autonomous driving scenarios. The dataset provides annotated video sequences with rich temporal and spatial information, enabling research into road-event detection, object tracking, and situational awareness for autonomous vehicles.",

    contribution: {
      title: "My Contribution",

      description:
        "I contributed to the data annotation and quality-control pipeline of the ROAD dataset. I led a team of annotators responsible for labeling video sequences and ensuring that assigned videos were completed and delivered within the required deadlines.",

      responsibilities: [
        "Managed and coordinated a team of data annotators responsible for labeling video sequences.",
        "Monitored annotation progress and ensured assigned videos were completed and delivered within the required deadlines.",
        "Developed Python scripts to automatically identify common annotation errors and inconsistencies.",
        "Detected issues such as incorrect left/right directional labels and contradictory states, including objects being simultaneously marked as moving forward and stationary.",
        "Reviewed detected inconsistencies, corrected straightforward errors when possible, and referred ambiguous cases back to the responsible annotators for relabeling.",
        "Performed quality-control checks to improve the consistency and reliability of the annotated dataset.",
      ],
    },

    skills: [
      "Python",
      "Data Annotation",
      "Data Quality Control",
      "Dataset Validation",
      "Computer Vision",
      "Team Coordination",
      "Automation",
    ],

    dataset: "ROAD (The ROad event Awareness Dataset)",

    method:
      "The project introduced a dataset and benchmark for road-event awareness in autonomous driving, including object detection, tracking, and temporal event understanding from video data.",

    links: {
      paper: "https://arxiv.org/abs/2102.11585",
      dataset: "https://www.road-dataset.com/",
      code: "https://github.com/gurkirt/3D-RetinaNet",
      doi: "https://doi.org/10.1109/TPAMI.2022.3150906",
    },

    identifiers: {
      arxiv: "2102.11585",
      doi: "10.1109/TPAMI.2022.3150906",
    },

    citation:
      'G. Singh, S. Akrigg, M. Di Maio, ..., F. Cuzzolin, "ROAD: The ROad event Awareness Dataset for Autonomous Driving," IEEE Transactions on Pattern Analysis and Machine Intelligence, 2022.',
  },

  fa: {
    title: "ROAD: مجموعه‌داده آگاهی از رویدادهای جاده‌ای برای رانندگی خودران",

    authors:
      "Gurkirt Singh, Stephen Akrigg, Manuele Di Maio, Valentina Fontana, Reza Javanmard Alitappeh, Suman Saha, Kossar Jeddisaravi, Farzad Yousefi , Jacob Culley, Tom Nicholson, Jordan Omokeowa, Salman Khan, Stanislao Grazioso, Andrew Bradley, Giuseppe Di Gironimo, Fabio Cuzzolin",

    venue:
      "IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI)",

    year: "۲۰۲۲",

    categories: [
      "بینایی ماشین",
      "هوش مصنوعی",
      "رانندگی خودران",
      "رباتیک",
      "یادگیری عمیق",
    ],

    description:
      "ROAD یک مجموعه‌داده گسترده برای شناسایی و درک رویدادهای جاده‌ای در سناریوهای رانندگی خودران است. این مجموعه شامل دنباله‌های ویدئویی حاوی اطلاعات مکانی و زمانی غنی است و امکان پژوهش در زمینه‌هایی مانند تشخیص رویدادهای جاده‌ای، ردیابی اشیا و آگاهی موقعیتی خودروهای خودران را فراهم می‌کند.",

    contribution: {
      title: "مشارکت من در پژوهش",

      description:
        "مشارکت من در این پژوهش در بخش برچسب‌گذاری و کنترل کیفیت داده‌های مجموعه‌داده ROAD بود. من مسئولیت یک تیم از برچسب‌گذاران را بر عهده داشتم که وظیفه آن‌ها برچسب‌گذاری دنباله‌های ویدئویی و تحویل آن‌ها در مهلت‌های تعیین‌شده بود.",

      responsibilities: [
        "مدیریت و هماهنگی یک تیم از برچسب‌گذاران مسئول برچسب‌گذاری دنباله‌های ویدئویی.",
        "پیگیری روند برچسب‌گذاری و اطمینان از تکمیل و تحویل ویدئوهای اختصاص‌یافته در مهلت تعیین‌شده.",
        "توسعه اسکریپت‌های پایتون برای شناسایی خودکار خطاها و ناسازگاری‌های رایج در برچسب‌ها.",
        "شناسایی خطاهایی مانند ثبت نادرست جهت حرکت چپ و راست و وضعیت‌های متناقض، مانند ثبت هم‌زمان حرکت رو به جلو و حالت ایستاده برای یک شیء.",
        "بررسی ناسازگاری‌های شناسایی‌شده، اصلاح خطاهای ساده در صورت امکان و ارجاع موارد مبهم به برچسب‌گذار مربوطه برای برچسب‌گذاری مجدد.",
        "انجام کنترل‌های کیفی برای افزایش سازگاری و قابلیت اطمینان داده‌های برچسب‌گذاری‌شده.",
      ],
    },

    skills: [
      "Python",
      "برچسب‌گذاری داده",
      "کنترل کیفیت داده",
      "اعتبارسنجی مجموعه‌داده",
      "بینایی ماشین",
      "هماهنگی تیم",
      "خودکارسازی",
    ],

    dataset: "ROAD (مجموعه‌داده آگاهی از رویدادهای جاده‌ای)",

    method:
      "این پژوهش یک مجموعه‌داده و چارچوب ارزیابی برای آگاهی از رویدادهای جاده‌ای در رانندگی خودران ارائه می‌کند که شامل تشخیص و ردیابی اشیا و درک رویدادهای زمانی از داده‌های ویدئویی است.",

    links: {
      paper: "https://arxiv.org/abs/2102.11585",
      dataset: "https://www.road-dataset.com/",
      code: "https://github.com/gurkirt/3D-RetinaNet",
      doi: "https://doi.org/10.1109/TPAMI.2022.3150906",
    },

    identifiers: {
      arxiv: "2102.11585",
      doi: "10.1109/TPAMI.2022.3150906",
    },

    citation:
      "G. Singh, S. Akrigg, M. Di Maio, ...، F. Cuzzolin، «ROAD: The ROad event Awareness Dataset for Autonomous Driving»، IEEE Transactions on Pattern Analysis and Machine Intelligence، ۲۰۲۲.",
  },
};

export function Publication({ t }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <section className={styles.sectionContainer} id="Poblications">
      <div className={styles.header}>
        <SectionTitle
          text={publicationDictionary[lang].sectionTitle}
          num={publicationDictionary[lang].sectionNum}
        />
      </div>
      <div className={styles.articleContainer}>
        <div>
          <div className={styles.rowContainer}>
            <div>
              <GraduationCap />
              <label>{publicationDictionary[lang].title}</label>
            </div>
            <h3>
              <a target="_blank" href="https://arxiv.org/abs/2102.11585">
                {publication[lang].title}
              </a>
            </h3>
          </div>
          <div className={styles.rowContainer}>
            <div>
              <PenTool />
              <label>{publicationDictionary[lang].authors}</label>
            </div>
            <h3>{publication[lang].authors}</h3>
          </div>
          <div className={styles.rowContainer}>
            <div>
              <Printer />
              <label>{publicationDictionary[lang].publisher}</label>
            </div>
            <h3>{publication[lang].venue}</h3>
          </div>
          <div className={styles.rowContainer}>
            <div>
              <Summary />
              <label>{publicationDictionary[lang].abstract}</label>
            </div>
            <h3>{publication[lang].description}</h3>
          </div>
          <div className={styles.tagContainer}>
            {publication[lang].categories.map((tag, index) => (
              <Tag text={tag} />
            ))}
          </div>
          <div className={styles.rowContainer}>
            <div>
              <Handshake />
              <label>{publication[lang].contribution.title}</label>
            </div>
            <h3>{publication[lang].contribution.description}</h3>
          </div>

          <div className={styles.tagContainer}>
            {publication[lang].skills.map((tag, index) => (
              <Tag text={tag} />
            ))}
          </div>
        </div>
        <img src="imgs/Publication/article.JPG" />
      </div>
    </section>
  );
}
